<template>
  <nav-header :title="title"></nav-header>
  <main class="statistics-page">
    <div class="container statistics-container">
      <nav class="statistics-menu-card" aria-label="FiNN-statistik">
      <router-link to="/finn/statistik/projekt" class="statistics-menu-link">
        <span class="menu-link-icon"><i class="material-icons">bar_chart</i></span>
        <span>Generel FiNN-statistik</span>
        <i class="material-icons" aria-hidden="true">chevron_right</i>
      </router-link>
      <router-link to="/finn/statistik/personlig" class="statistics-menu-link">
        <span class="menu-link-icon"><i class="material-icons">person</i></span>
        <span>Min FiNN-statistik</span>
        <i class="material-icons" aria-hidden="true">chevron_right</i>
      </router-link>
      <router-link to="/finn/statistik/område" class="statistics-menu-link">
        <span class="menu-link-icon"><i class="material-icons">public</i></span>
        <span>FiNN-områdestatistik</span>
        <i class="material-icons" aria-hidden="true">chevron_right</i>
      </router-link>
      </nav>
    </div>
  </main>
</template>

<script>
import NavHeader from "@/components/navbars/NavHeader.vue";
import siteRepository from "../idb/repositories/siteRepository";
import specieRepository from "../idb/repositories/specieRepository";
import primaryBehaviourRepository from "../idb/repositories/primaryBehaviourRepository";

export default {
  components: {
    NavHeader,
  },
  data() {
    return {
      title: this.$englishPreferred ? "FiNN-statistics" : "FiNN-statistik",
    };
  },
};
</script>

<style scoped>
:deep(#navbar) {
  margin-bottom: 0 !important;
}
</style>
